// extracted by mini-css-extract-plugin
export default {"loadingDisplay":"waiting_loadingDisplay__cYj5m","loadingDisplayMessage":"waiting_loadingDisplayMessage__QyR0Z","linkText":"waiting_linkText__B3o8B"};